import React, { Component } from "react"
import PropTypes from "prop-types"
import { Col, Card, CardBody } from "reactstrap"
import NumberFormat from "react-number-format"

class InfoComp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      orders1: 0,
      slRev1: 0,
      orders2: 0,
      slRev2: 0,
      receivedOrders: 0,
    }
    this.calcDiff = this.calcDiff.bind(this)
  }
  calcDiff = (num1, num2) => {
    const checkZero = num2 === 0 ? 1 : num2
    let orderDifference = ((num1 / checkZero - 1) * 100).toFixed(2)
    return orderDifference > 100 ? 100 : orderDifference 
  }

  render() {
    const { curInfo, pastInfo } = this.props.props
    const info = [
      {
        icon: "bx bx-user-plus",
        title: "New Clients Statistics",
        value: `New Clients: ${curInfo.amountOfNewClients}`,
        value2: curInfo.totalNewClientsSaleAmount,
        badgeValue: `${this.calcDiff(curInfo.amountOfNewClients, pastInfo.amountOfNewClients) > 0 ? "+" : ""} ${this.calcDiff(curInfo.amountOfNewClients, pastInfo.amountOfNewClients)}%`,
        color: `${
          this.calcDiff(curInfo.amountOfNewClients, pastInfo.amountOfNewClients) > 0
            ? this.calcDiff(curInfo.amountOfNewClients, pastInfo.amountOfNewClients) === 0
              ? "warning"
              : "success"
            : "danger"
        }`,
        desc: "From previous period",
      },
      {
        icon: "bx bx-copy-alt",
        title: "Paid and Sent Orders",
        value: `${curInfo.amountOfPSOrders}`,
        badgeValue: `${this.calcDiff(curInfo.amountOfPSOrders, pastInfo.amountOfPSOrders) > 0 ? "+" : ""} ${this.calcDiff(curInfo.amountOfPSOrders, pastInfo.amountOfPSOrders)}%`,
        color: `${
          this.calcDiff(curInfo.amountOfPSOrders, pastInfo.amountOfPSOrders) > 0
            ? this.calcDiff(curInfo.amountOfPSOrders, pastInfo.amountOfPSOrders) === 0
              ? "warning"
              : "success"
            : "danger"
        }`,
        desc: "From previous period",
      },
      {
        icon: "bx bx-archive-in",
        title: "Revenue",
        value: curInfo.totalSaleAmount,
        badgeValue: `${this.calcDiff(curInfo.totalSaleAmount, pastInfo.totalSaleAmount) > 0 ? "+" : ""} ${this.calcDiff(curInfo.totalSaleAmount, pastInfo.totalSaleAmount)}%`,
        color: `${
          this.calcDiff(curInfo.totalSaleAmount, pastInfo.totalSaleAmount) > 0
            ? this.calcDiff(curInfo.totalSaleAmount, pastInfo.totalSaleAmount) === 0
              ? "warning"
              : "success"
            : "danger"
        }`,
        desc: "From previous period",
      },
      {
        icon: "bx bx-purchase-tag-alt",
        title: "Received Orders",
        value: `${curInfo.amountOfReceivedOrders}/${curInfo.amountOfAllOrders}`,
        desc: "Marked by accounting",
      },
    ]
    return (
      <React.Fragment>
        {/* <p className="text-muted ms-2">Sales Statistics</p> */}
        {info.map((info, key) => (
        <Col sm="3" key={key}>
          <Card className="dashboard-card">
            <CardBody>
              <div className="d-flex align-items-center mb-3">
                <div className="avatar-xs me-3">
                  <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                    <i className={info.icon} />
                  </span>
                </div>
                <h5 className="font-size-18 mb-0 make-text-bold">
                  {info.title}
                </h5>
              </div>
              <div className="text-muted mt-2 ">
                <h3 className="make-text-bold">
                  {info.value === curInfo.totalSaleAmount ? (
                    <NumberFormat
                      value={info.value && info.value.toFixed(2)}
                      displayType="text"
                      thousandSeparator={true}
                      prefix="$"
                    />
                  ): info.value }
                  {info.value2 !== undefined && (
                    <>
                    &emsp;&emsp;Sales: <NumberFormat
                      value={info.value2}
                      displayType="text"
                      thousandSeparator={true}
                      prefix="$"
                    />
                    </>
                  )}{" "}
                </h3>
                {info.desc && <div className="d-flex">
                  <span className={ "badge badge-soft-" + info.color + " font-size-12 pt-2" }>
                    {" "}
                    {info.badgeValue !== undefined ? info.badgeValue : "N/A"}{" "}
                  </span>
                  <span className="ms-2 text-truncate font-size-14">
                    {info.desc}
                  </span>
                </div>}
              </div>
            </CardBody>
          </Card>
        </Col>
        ))}
      </React.Fragment>
    )
  }
}

InfoComp.propTypes = {
  info: PropTypes.array,
}

export default InfoComp
